//network.js
export const HttpMethod = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE'
};

export const getBaseUrl = async () => {
  return 'https://emr-backend-3o6h.onrender.com/api/';
  // return 'http://localhost:3005/api/';
};

// export const getWhatsAppUrl = async () => {
//   return 'https://whatsapp-services.onrender.com/api/ ';
// };
